var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 19,
    viewBox: "0 0 28 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.3431 0H2.32361C1.04028 0 0 1.05885 0 2.3651V16.6349C0 17.9411 1.04028 19 2.32361 19H16.3431C17.6264 19 18.6667 17.9411 18.6667 16.6349V2.3651C18.6667 1.05885 17.6264 0 16.3431 0ZM25.55 1.86536L20.2222 5.60599V13.394L25.55 17.1297C26.5806 17.8521 28 17.1148 28 15.8531V3.14193C28 1.88516 26.5854 1.14297 25.55 1.86536Z",
    style: {
      fill: "#59A3CF"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoActive);
export default __webpack_public_path__ + "static/media/video-active.1d63a1844a287614813737bfb96a07af.svg";
export { ForwardRef as ReactComponent };